var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Button } from './button';
function Logotype(_a) {
    var item = _a.item;
    return (React.createElement("a", __assign({ className: 'autonet-logotype-item element-flex' }, item.linkUrl ? { href: item.linkUrl, target: '_blank' } : {}),
        React.createElement("img", { width: '200', height: '100', src: item.imgPath, alt: item.title })));
}
export function Logotypes(props) {
    var _a = React.useState([]), items = _a[0], setItems = _a[1];
    var _b = React.useState(false), loadMorePossible = _b[0], setLoadMorePossible = _b[1];
    var itemThreshold = 10;
    React.useEffect(function () {
        if (props.items.length > itemThreshold) {
            var newItemsArr = props.items.slice(0, itemThreshold);
            setItems(newItemsArr);
            setLoadMorePossible(true);
            return;
        }
        setItems(props.items);
    }, []);
    var handleLoadMore = function () {
        setItems(props.items);
        setLoadMorePossible(false);
    };
    return (React.createElement("div", { className: 'autonet-logotype-listing autonet-listing element-flex' },
        items.map(function (item, index) {
            return React.createElement(Logotype, { key: "".concat(item.contentId, "-").concat(index + 1), item: item });
        }),
        loadMorePossible &&
            React.createElement(Button, { onClick: handleLoadMore, style: 'text-like', title: props.loadMoreLabel, label: props.loadMoreLabel, alignment: 'align-center' })));
}
